export const STOW_AREA_OPERATION = {
    PREPARE_CONTAINER: 'prepareContainer',
    CLOSE_CONTAINER: 'closeContainer',
}
